import { Injectable } from '@angular/core';
import { HeaderData } from './header/headerData';
import { TagBreadcrumbs } from './header/tagBreadcrumbs';

@Injectable()
export class AppService {
  public messages = [];
  public headerData: HeaderData = new HeaderData('Default');
  public tagBreadcrumbs: TagBreadcrumbs = new TagBreadcrumbs();

  addFlashMessage(message: Object) {
    this.messages.push(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts